export class ObjUtils {
    static instance: ObjUtils
    utils: any = null

    constructor(utils: any) {
        if (ObjUtils.instance) {
            return ObjUtils.instance
        }

        this.utils = utils

        ObjUtils.instance = this
        return this
    }
}
